var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { BlockStatusClient, CompaniesClient, SitesClient, ReportScheduleModel, GetBlockStatusQuery } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
const blockStatusClient = new BlockStatusClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let BlockStatusReportFilterVue = class BlockStatusReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.companies = [];
        this.sites = [];
        this.query = new GetBlockStatusQuery();
    }
    created() {
        this.getLookups();
    }
    ;
    mounted() {
        this.loadReportScheduleQuery();
    }
    ;
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `Any company` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        var _a;
        var _b;
        this.query.timezoneOffset = moment().utcOffset();
        (_a = (_b = this.query).filterStringsWithNoAlarmOnDetails) !== null && _a !== void 0 ? _a : (_b.filterStringsWithNoAlarmOnDetails = false);
        return this.query;
    }
    ;
    exportToPdf() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        this.working = true;
        blockStatusClient.downloadBlockStatusAsPDF(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        this.working = true;
        blockStatusClient.downloadBlockStatusAsCsv(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    ;
    onCompanyIdChanged() {
        if (!this.working)
            this.query.siteId = null;
    }
    schedule() {
        var reportQuery = this.getQuery();
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            var query = JSON.parse(queryString);
            this.working = true;
            this.query.companyId = query.companyId;
            this.query.siteId = query.siteId;
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.query.companyId || site.companyId == this.query.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `Any site` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], BlockStatusReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BlockStatusReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BlockStatusReportFilterVue.prototype, "onCompanyIdChanged", null);
BlockStatusReportFilterVue = __decorate([
    Component({
        name: "BlockStatusReportFilterVue",
        emits: ["schedule", "updateSchedule"]
    })
], BlockStatusReportFilterVue);
export default BlockStatusReportFilterVue;
